import React from "react"

function IconOneByOne({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (<svg  fill={color} fuze-icon="one-by-one"viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{height: height || fontSize}} originalclass="fz-icon fz-icon-one-by-one"{...props}><path d="M7.35 17.455V6.545l-4.077.385v1.425h2.282v9.1H7.35zm5.968-6.47V9.262H11.53v1.721h1.788zm0 6.47v-1.721H11.53v1.72h1.788zm6.684 0V6.545l-4.077.385v1.425h2.282v9.1h1.795z" fill={color} fillRule="evenodd" style={{height: height || fontSize}} originalclass="__primary"/></svg>)
}

export default IconOneByOne
